import type { ConfirmationCodeResult } from './common'

import { useIntl } from 'react-intl'
import { nonNullable } from 'lib/array/arrayUtils'
import { useFlightDetailsForItems } from '../api/flights'
import type { FlightItem } from 'tripPlanner/types/tripItem'

export default function useFlightItemConfirmationCodes(
  item: FlightItem,
): ConfirmationCodeResult {
  const intl = useIntl()
  const { sourceType, confirmationCode, confirmationItemCodes, isBooked } = item
  const isLeBooking = !!(
    sourceType === 'LE_Flight' &&
    isBooked &&
    confirmationCode &&
    confirmationItemCodes &&
    confirmationItemCodes.length > 0
  )

  const {
    data: flightDetails,
    isSuccess,
    isLoading,
  } = useFlightDetailsForItems({
    orderId: confirmationCode!,
    itemIds: confirmationItemCodes,
    enabled: isLeBooking,
  })

  if (isLeBooking) {
    const pnrIds = flightDetails ?
        nonNullable(flightDetails.map((fd) => fd.pnrId)) :
        []

    const airlineBookingLabel = intl.formatMessage({
      id: 'szqc62gB6g',
      defaultMessage: '{count, plural, one {Airline Booking Reference} other {Airline Booking References}}',
      description: 'Label for airline booking reference codes in trip planner flight details',
    }, { count: pnrIds.length || 1 })

    if (isSuccess && pnrIds.length > 0) {
      return {
        hasCode: true,
        codes: pnrIds,
        codeString: pnrIds.join(', '),
        label: airlineBookingLabel,
        isLoading,
      }
    } else {
      return {
        hasCode: false,
        codes: [],
        codeString: '',
        label: airlineBookingLabel,
        isLoading,
      }
    }
  } else {
    const confirmationCode = item.confirmationCode
    return {
      hasCode: !!confirmationCode,
      codes: nonNullable([confirmationCode]),
      codeString: confirmationCode,
      label: intl.formatMessage({
        id: 'OjIj3ibaw9',
        defaultMessage: 'Confirmation number',
        description: 'Label for confirmation number in trip planner flight details',
      }),
      isLoading: false,
    }
  }
}
